import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SearchProductsQuery } from "../../../common/generated-types";
import { buildProductRoute } from "../../../common/utils/build-product-route";

@Component({
    selector: "vsf-product-card",
    templateUrl: "./product-card.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardComponent implements OnInit {
    @Input() product: SearchProductsQuery["search"]["items"][number];
    supplierId: string | null = null;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.route.paramMap.subscribe((paramMap) => {
            this.supplierId = paramMap.get("supplierId");
        });
    }

    get productRoute(): string[] {
        return buildProductRoute(this.product.slug, this.supplierId);
    }
}
